import React, { useState, useEffect } from "react";
import {
  Table,
  Input,
  Button,
  Space,
  Popconfirm,
  message,
  Modal,
  Switch,
  Menu,
  Dropdown,
  Tag,
} from "antd";
import {
  SearchOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { API_LIST_STORE, API_DELETE_STORE } from "api/store-managemnt"; // Import your API functions
import EditStore from "views/admin/storeManagement/EditStore";
import ViewStore from "views/admin/storeManagement/ViewStore/ViewStore";
import { API_LIST_LAUNDRY_MEN } from "api/laundry-management";
import EditLaundryMan from "views/admin/laundrymanManagement/EditLaundryMan";
import ViewLaundryMan from "views/admin/laundrymanManagement/ViewLaundryMan/ViewLaundryMan";
import { API_DELETE_LAUNDRY_MEN } from "api/laundry-management";
import { CONSTANTS } from "config/constant";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import profile from "../../../assets/img/orders/orderDetail/userplace.png";
import money from "../../../assets/img/icons/money.png";
import { API_ENABLE_DISABLE_DRIVER } from "api/laundry-management";
import { LuRefreshCcw } from "react-icons/lu";
import { IoRefreshCircleOutline } from "react-icons/io5";
import { TbRefresh } from "react-icons/tb";
import { PiNotepad } from "react-icons/pi";
import { API_ASSIGN_ORDER_TO_DRIVER } from "api/laundry-management";
import { API_LIST_ORDER } from "api/order-management";
import { API_WITHDRAW } from "api/laundry-management";
import OtpModal from "components/Modal/OtpModal";
import { API_WITHDRAW_NOTIFICATION } from "api/laundry-management";
import { toast } from "react-toastify";
const { Column } = Table;
const { TextArea } = Input;
const DashboaredLaundryMen = () => {
  const [data, setData] = useState([]);
  const [showWithDrawModal, setShowWithDrawModal] = useState(false);
  const [dataOrder, setDataOrder] = useState([]);
  const [loadingOrder, setLoadingOrder] = useState(false);

  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 4 }); // Initial pagination settings
  const [paginationOrder, setPaginationOrder] = useState({
    current: 1,
    pageSize: 8,
  }); // Initial pagination settings
  const [laundryMenId, setLaundryMenId] = useState("");
  const [searchName, setSearchName] = useState("");
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [selectedStore, setSelectedStore] = useState(null);
  const [assignOrderModalVisible, setAssignOrderModalVisible] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [withDrawAmount, setWithDrawAmount] = useState("");
  const [amountError, setAmountErrror] = useState("");
  const [otp, setOtp] = useState("");
  const [isValid, setIsValid] = useState(false);
  const [isOtpModalVisible, setIsOtpModalVisible] = useState(false);

  const showOtpModal = () => setIsOtpModalVisible(true);
  const closeOtpModal = () => setIsOtpModalVisible(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      setLoading(true);
      const params = {
        page: pagination.current,
        limit: pagination.pageSize,
        name: searchName,
      };
      const newData = await API_LIST_LAUNDRY_MEN(params);
      console.log("provider", newData);
      setData(newData?.data);
      setLoading(false);
      setPagination({
        ...pagination,
        total: newData?.data?.totalLaundryMen,
      }); // Assuming API response contains total count
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const fetchDataOrder = async (page) => {
    try {
      setLoading(true);
      const params = {
        page: page,
        limit: paginationOrder.pageSize,
        name: "",
      };
      const newData = await API_LIST_ORDER(params);
      setDataOrder((prevData) => [...prevData, ...newData?.orders]);
      setPaginationOrder((prevPagination) => ({
        ...prevPagination,
        totalPages: newData.total_pages,
      }));
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      // setLoading(false);
    }
  };

  // const fetchDataOrder = async () => {
  //   try {
  //     setLoading(true);
  //     const params = {
  //       page: paginationOrder.current,
  //       limit: paginationOrder.pageSize,
  //       name: "",
  //     };
  //     const newData = await API_LIST_ORDER(params);
  //     console.log("provider", newData);
  //     setDataOrder(newData);
  //     setLoadingOrder(false);
  //     setPaginationOrder({
  //       ...pagination,
  //       total: newData?.data?.total_orders,
  //     }); // Assuming API response contains total count
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //     setLoadingOrder(false);
  //   }
  // };

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleSearch = (value) => {
    setSearchName(value);
  };

  const handleEdit = (record) => {
    setSelectedStore(record);
    setEditModalVisible(true);
    navigate(`/admin/laundryman-management/edit/${record._id}`, {
      state: { data: record },
    });
  };

  const handleView = (record) => {
    setSelectedStore(record);
    setViewModalVisible(true);
    navigate(`/admin/laundryman-management/${record?._id}`, {
      state: { data: record },
    });
  };

  const handleDelete = async (id) => {
    try {
      let a = await API_DELETE_LAUNDRY_MEN(id);
      message.success(a?.message);
      fetchData(); // Refresh data after delete
    } catch (error) {
      console.error("Error deleting store:", error);
      message.error("Failed to delete store");
    }
  };

  const handleEditModalOk = () => {
    // Implement edit store logic here
    console.log("Editing store:", selectedStore);
    setEditModalVisible(false);
  };

  const handleViewModalOk = () => {
    // Implement view store logic here
    console.log("Viewing store:", selectedStore);
    setViewModalVisible(false);
  };

  const handleModalCancel = () => {
    setEditModalVisible(false);
    setViewModalVisible(false);
  };
  const handleSwitchChange = async (checked, record) => {
    try {
      const response = await API_ENABLE_DISABLE_DRIVER(record._id); // Assuming API_ENABLE_DISABLE_DRIVER accepts driver ID and status as parameters
      message.success(response?.message);
      fetchData(); // Refresh data after delete
    } catch (error) {
      console.error("Error toggling driver status:", error);
      message.error("Failed to toggle driver status");
    }
  };

  const getRowClassName = (record, index) => {
    return index % 2 === 0 ? "even-row" : "odd-row";
  };
  const handleAssignOrder = (driver, order) => {
    console.log("order ==>", driver, order);
    setSelectedDriver(driver);
    setSelectedOrder(order);
    setAssignOrderModalVisible(true);
  };

  const confirmAssignOrder = async () => {
    try {
      const payload = {
        laundry_man_id: selectedDriver._id,
        order_id: selectedOrder._id,
      };

      const response = await API_ASSIGN_ORDER_TO_DRIVER(payload);
      message.success(response?.message);
      setAssignOrderModalVisible(false);
      fetchData(); // Refresh data after assigning order
    } catch (error) {
      console.error("Error assigning order to driver:", error);
      message.error("Failed to assign order to driver");
    }
  };

  // Scroll things and functioanlity

  const handleScroll = (e) => {
    const { target } = e;
    if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
      if (paginationOrder.current < paginationOrder.total_pages) {
        setPagination((prevPagination) => ({
          ...prevPagination,
          current: paginationOrder.current + 1,
        }));
      }
    }
  };

  // Scroll things and functionalty

  const menu = (driver) => (
    <Menu>
      {dataOrder?.map((order) => (
        <Menu.Item
          key={order?._id}
          onClick={() => handleAssignOrder(driver, order)}
        >
          {order?.order_type}
        </Menu.Item>
      ))}
    </Menu>
  );

  const handleWithDraw = async () => {
    if (withDrawAmount === "") {
      setAmountErrror("Please select amount to withdraw");
      return;
    }
    const dataToSend = {
      laundry_man: laundryMenId?.id,
      amount: withDrawAmount,
      // description: "Withdraw Amount",
    };
    try {
      // const res = await API_WITHDRAW(dataToSend);
      const res = await API_WITHDRAW_NOTIFICATION(dataToSend);

      if (res) {
        showOtpModal();
        console.log("res ===>", res);
        toast.success(res?.message);
        fetchData();
        handleCancel();
      }
    } catch (e) {
      toast.error(e?.message);

      console.log(e);
    }
  };

  const handleVerify = async () => {
    const dataToSend = {
      laundry_man: laundryMenId?.id,
      // amount: withDrawAmount,
      // description: "Withdraw Amount",
      description: "Withdraw Amount",
      pin: otp,
    };
    try {
      const res = await API_WITHDRAW(dataToSend);
      if (res) {
        showOtpModal();
        console.log("res ===>", res);
        toast.success(res?.message);
        fetchData();
        handleCancel();
        setIsOtpModalVisible(false);
      }
    } catch (e) {
      toast.error(e?.response?.data?.message);

      console.log(e);
    }
  };

  const handleSelectDriver = (record) => {
    setLaundryMenId({ id: record?._id, balance: record?.wallet?.balance });
    setShowWithDrawModal(true);
  };
  const handleChange = (e) => {
    const value = e.target.value;
    const numericValue = Number(value);
    const balance = Number(laundryMenId?.balance);
    if (numericValue <= balance) {
      setWithDrawAmount(value);
    }
  };
  const handleCancel = () => {
    setShowWithDrawModal(false);
    setWithDrawAmount("");
    // setLaundryMenId("");
    setAmountErrror("");
  };
  console.log(laundryMenId, "laundryMenId");
  // <<<<<<<<<<<<<<<<<<<<<<<---------------------Effects----------------------->>>>>>>>>>>>>>>>
  useEffect(() => {
    fetchData();
  }, [pagination.current, pagination.pageSize, searchName]);
  useEffect(() => {
    fetchDataOrder(pagination.current);
  }, [pagination.current]);

  return (
    <div className="aza">
      {/* <div className=" mb-4 flex justify-between">
        <Input
          className="border-none"
          placeholder={t("Search by name")}
          prefix={<SearchOutlined />}
          allowClear
          onChange={(e) => handleSearch(e.target.value)}
          style={{ width: 200 }}
        />
        <div className="flex items-center gap-4">
          <TbRefresh className="h-8 w-8 cursor-pointer" onClick={fetchData} />
          <Link
            to={"/admin/laundryman-management/create-store"}
            className="linear p-[4px 11px] flex w-full max-w-[10rem] cursor-pointer items-center justify-center rounded-xl bg-brand-500 py-2 text-center text-base font-medium text-white transition duration-200 hover:bg-white hover:text-brand-500 dark:bg-brand-400 dark:text-white  dark:active:bg-brand-200"
          >
            + {t("Create Driver")}
          </Link>
        </div>
      </div> */}
      <Table
        dataSource={data?.laundryMen}
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
        rowKey={(record) => record.id} // Assuming each record has a unique id
        rowClassName={getRowClassName} // Apply alternating row colors
        scroll={{ x: true }}
      >
        {/* <Column
          title={t("sr#")}
          dataIndex="plan_title"
          key="plan_title"
          render={(text, record, index) => index + 1}
        /> */}
        <Column
          title={t("Profile Image")}
          dataIndex="profile_image.[0].file_url"
          key="profile_image"
          width="5rem"
          render={(text, record) => (
            <span>
              <img
                src={
                  record?.profile_image?.[0]?.file_url
                    ? CONSTANTS?.IMG_DIRECTORY +
                      record?.profile_image?.[0]?.file_url
                    : profile
                }
                alt=""
                style={{
                  width: "4rem",
                  height: "4rem",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            </span>
          )}
        />

        <Column
          title={t("First Name")}
          dataIndex="first_name"
          key="first_name"
          width="9rem"
        />
        <Column
          title={t("Email")}
          key="email "
          dataIndex="email"
          width="9rem"
          render={(text, record) => <span>{record?.email}</span>}
        />
        {/* <Column title={t("Role")} dataIndex="role" key="role" /> */}
        <Column
          title={t("Phone No")}
          dataIndex="phone_no"
          key="phone_no"
          width="9rem"
          render={(text, record) => <span>{record?.phone_no}</span>}
        />

        <Column
          title={t("Order Assigned")}
          dataIndex="order_count"
          key="order_count"
          width="9rem"
          // render={(text, record) => (
          //   record?.status ==
          // )}
        />
        {/* <Column
          title={t("Picked-up Order")}
          dataIndex="order_count"
          key="order_count"
          width="9rem"
          // render={(text, record) => (
          //   record?.status ==
          // )}
        /> */}

        {/* <Column
          title={t("Delivered Order")}
          dataIndex="order_count"
          key="order_count"
          width="9rem"
          // render={(text, record) => (
          //   record?.status ==
          // )}
        /> */}

        <Column
          title={t("Total amount")}
          dataIndex="is_online"
          key="is_online"
          width="9rem"
          render={(text, record) =>
            record?.wallet?.balance
              ? record?.wallet?.balance + " SAR"
              : "No balance"
          }
        />
        {/* <Column
          title={t("Current status")}
          dataIndex="is_online"
          key="is_online"
          width="9rem"
          render={(text, record) =>
            record?.is_online === false ? (
              <Tag color="red">Offline</Tag>
            ) : (
              <Tag color="green">Online</Tag>
            )
          }
        /> */}
        {/* <Column
          title={t("Location")}
          dataIndex="status"
          key="status"
          // render={(text, record) => (
          //   record?.status ==
          // )}
        /> */}
        {/* <Column
          title={t("Status")}
          dataIndex="is_disable"
          key="is_disable"
          width="9rem"
          render={(text, record) => (
            <Switch
              checked={!record.is_disable}
              onChange={(checked) => handleSwitchChange(checked, record)}
            />
          )}
        /> */}

        <Column
          title={t("Actions")}
          key="actions"
          width="12rem"
          render={(text, record) => (
            <div className="flex flex-row items-center">
              {/* <div className="flex flex-row items-center gap-2">
                <button onClick={() => handleSelectDriver(record)}>
                  {" "}
                  <img
                    src={money}
                    alt=""
                    className="h-[30px] w-[30px] text-[black]"
                  />
                </button>
                <Button
                  type="primary"
                  icon={<EditOutlined />}
                  onClick={() => handleEdit(record)}
                ></Button>
              </div>

              <Popconfirm
                title="Are you sure to delete this Driver?"
                onConfirm={() => handleDelete(record?._id)}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  type="danger"
                  icon={<DeleteOutlined />}
                  style={{ border: "1px solid #d9d9d9", marginLeft: "5px" }}
                ></Button>{" "}
              </Popconfirm> */}
              <Button
                type="default"
                icon={<EyeOutlined />}
                onClick={() => handleView(record)}
                style={{ marginLeft: "5px" }}
              ></Button>
              {/* <Dropdown
                className="custom-order-dropdown"
                overlay={menu(record)}
                trigger={["click"]}
              >
                <Button
                  type="default"
                  icon={<PiNotepad />}
                  style={{ marginLeft: "5px" }}
                />
              </Dropdown> */}
            </div>
          )}
        />
      </Table>

      <Modal
        key={selectedStore?._id}
        // title={t("Edit Driver")}
        visible={isOtpModalVisible}
        onOk={handleEditModalOk}
        onCancel={() => setIsOtpModalVisible(false)}
        centered
      >
        <OtpModal otp={otp} setOtp={setOtp} handleVerify={handleVerify} />
      </Modal>

      {/* Edit Store Modal */}
      <Modal
        key={selectedStore?._id}
        // title={t("Edit Driver")}
        visible={editModalVisible}
        onOk={handleEditModalOk}
        onCancel={handleModalCancel}
        style={{ minWidth: "65rem" }}
      >
        <EditLaundryMan driver={selectedStore} />
      </Modal>
      <Modal
        // title={t("Edit Driver")}
        centered
        visible={showWithDrawModal}
        onCancel={handleCancel}
      >
        <div className="mt-8 flex flex-col gap-5 ">
          <div className="flex flex-row items-center justify-between ">
            <p className="font-poppins text-[20px] font-medium leading-[28px] text-[#3860A4]">
              Total amount
            </p>
            <p className="font-poppins text-[16px] font-medium leading-[18px] text-[#3860A4]">
              {laundryMenId?.balance ?? 0} SAR
            </p>
          </div>
          <div className="flex flex-row items-center justify-between ">
            <p className="font-poppins text-[20px] font-medium leading-[28px] text-[#3860A4] ">
              Withdraw
            </p>
            <div>
              <input
                value={withDrawAmount ?? ""}
                max={laundryMenId?.balance}
                onChange={(e) => handleChange(e)}
                type="number"
                src=""
                alt=""
                className="h-[30px] rounded-[5px] border-[1px] border-gray-500 px-2 outline-none"
              />
              {amountError && (
                <p className="text-[10px] text-red-500">{amountError}</p>
              )}
            </div>
          </div>
          <hr />
          <div className="flex justify-center">
            <button
              onClick={handleWithDraw}
              className="btn-gradient h-[43px] w-[159px] rounded-[8px] font-bold text-white "
            >
              Withdraw
            </button>
          </div>
        </div>
      </Modal>

      {/* View Store Modal */}
      <Modal
        key={selectedStore?._id}
        // title={t("View Driver")}
        visible={viewModalVisible}
        onOk={handleViewModalOk}
        onCancel={handleModalCancel}
        style={{ minWidth: "60rem" }}
      >
        <ViewLaundryMan data={selectedStore} />
      </Modal>

      {/* Assign Order Modal */}
      {/* <Modal
        title={t("Assign Order")}
        visible={assignOrderModalVisible}
        onOk={confirmAssignOrder}
        onCancel={handleModalCancel}
      >
        <p>{t("Are you sure you want to assign this order to the driver?")}</p>
      </Modal> */}

      <Modal
        // title="Save Changes"
        visible={assignOrderModalVisible}
        onCancel={() => setAssignOrderModalVisible(false)}
        centered
        onOk={async () => {
          confirmAssignOrder();
          setAssignOrderModalVisible(false);
        }}
      >
        <div className="flex items-center" style={{ flexDirection: "column" }}>
          <div>
            <p className="mb-1 font-bold">Save Changes</p>
            <p className="mb-8 font-medium">
              Are you sure you want to assign this order to the driver?{" "}
            </p>
          </div>
          <div className="flex gap-4">
            <button
              className="linear text-black mt-2 w-full  rounded-xl py-[12px] text-base font-medium transition duration-200  dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
              onClick={() => setAssignOrderModalVisible(false)}
              style={{ width: "6rem" }}
            >
              Cancel
            </button>
            <button
              className="linear mt-2 w-full max-w-[10rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
              onClick={async () => {
                confirmAssignOrder();
                handleModalCancel();
              }}
            >
              Save Changes
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default DashboaredLaundryMen;
